@if (pw) {
  <div class="bt-table">
    <table>
      <tbody>
        @if (bas.ui.r.xs) {
          <tr>
            <td class="btt-label" colspan="2">
              {{ pw.findName }}
              <!-- <i
              class="ml-d"
              *ngIf="pw.productObj.mkgCartItemInfo"
              nz-icon [nzType]="'info-circle'"
              nz-tooltip
              [nzTooltipTitle]="pw.productObj.mkgCartItemInfo"
              >
            </i> -->
            @if (pw.productObj.mkgCartItemInfo) {
              <div class="text-italic fgc-gray-40 text-sm">
                {{ pw.productObj.mkgCartItemInfo }}
              </div>
            }
          </td>
        </tr>
      }
      <tr >
        @if (bas.ui.r.gtesm) {
          <td class="btt-label">
            {{ pw.findName }}
            <!-- <i
            class="ml-d"
            *ngIf="pw.productObj.mkgCartItemInfo"
            nz-icon [nzType]="'info-circle'"
            nz-tooltip
            [nzTooltipTitle]="pw.productObj.mkgCartItemInfo"
            >
          </i> -->
          @if (pw.productObj.mkgCartItemInfo) {
            <div class="text-italic fgc-gray-40 text-sm">
              {{ pw.productObj.mkgCartItemInfo }}
            </div>
          }
        </td>
      }
      <td class="" style="width: 120px;">
        @if (pw.showInput) {
          @if (pw.unlimited) {
            @if (pw.productObj.findGuestProduct && pw.productObj.gcsSize > 1) {
              <btlib-select-guests [pw]="pw" [gcs]="pw.guestCounts" (change)="onChange($event, 'guests')"></btlib-select-guests>
            } @else {
              <nz-input-number
                [nzMin]="0"
                [nzMax]="pw.available || bas.us.MAX_SAFE_INTEGER"
                [nzStep]="1"
                [(ngModel)]="pw.quantity"
                (ngModelChange)="onChange($event, 'input')"
                style="width: 70px;"
              ></nz-input-number>
            }
          } @else {
            <div  [class.text-center]="bas.ui.r.gtesm">
              <nz-switch
                [(ngModel)]="pw.checked"
                [nzCheckedChildren]="checkedTemplate"
                [nzUnCheckedChildren]="unCheckedTemplate"
                (ngModelChange)="onCheckbox($event)"
              ></nz-switch>
              <ng-template #checkedTemplate><span nz-icon nzType="check"></span></ng-template>
              <ng-template #unCheckedTemplate><span nz-icon nzType="close"></span></ng-template>
            </div>
          }
        }
      </td>
      <td class="text-right" style="width: 120px;">
        @if (pw.showPrice) {
          <div>
            {{ pw.amountDouble | nf }}
          </div>
        }
      </td>
    </tr>
  </tbody>
</table>
</div>
}
